export default __webpack_public_path__ + "media/images/mail/twitter-ca73499f4381601f7b9423537988bedf.png";